import clsx from 'clsx';
import { XIcon } from 'lucide-preact';

import style from './style.scss';

const CloseButton = ({ className, onClick, varient }) => (
  <button
    type="button"
    aria-label="Close Button"
    onClick={onClick}
    className={clsx(style.close, className, { [style[varient]]: varient })}
  >
    <XIcon className="size-[1em]" />
  </button>
);

export default CloseButton;
